import { useQuery } from "@apollo/client/react";
import GET_ALL_RISK_SCORES from "../../queries/aml/getAllRiskScores";
import type { AmlRiskScoreModel } from "../../../models/AmlRiskScoreModel";

type RiskScoreEventsResponse = {
  riskScores: AmlRiskScoreModel;
};

export const useAllRiskScoreEvents = (
  sortDirection?: "ASC" | "DESC",
  createdFrom?: Date,
  createdTo?: Date,
  sortBy?: "CLIENT_NAME" | "CREATED_AT" | "RISK_SCORE",
  onlyWithManualRiskScoreAdjustment?: boolean,
  riskScoreClasses?: Array<"HIGH" | "MEDIUM" | "NONE" | "NORMAL">,
  skip?: number,
  take?: number
) => {
  const { data, error, loading, refetch } = useQuery<RiskScoreEventsResponse>(
    GET_ALL_RISK_SCORES,
    {
      variables: {
        sortDirection: sortDirection,
        createdFrom: createdFrom,
        createdTo: createdTo,
        sortBy: sortBy,
        onlyWithManualRiskScoreAdjustment: onlyWithManualRiskScoreAdjustment,
        riskScoreClasses: riskScoreClasses,
        skip: skip,
        take: take,
      },
      fetchPolicy: "no-cache",
    }
  );
  return { riskScores: data?.riskScores, error, loading, refetch };
};
